import { ExternalLinkIcon } from "@heroicons/react/solid";
import React from "react";
import classNames from "../utils/classNames";

interface Props {
  className?: string;
  iconStyle?: React.CSSProperties;
  text: string;
  url: string;
  iconComponent?: React.ComponentType<any>;
}

const ExternalLink: React.FC<Props> = ({
  className,
  iconStyle = {},
  text,
  url,
  iconComponent: Icon = ExternalLinkIcon
}) => (
  <a
    className={classNames(
      "flex items-center hover:text-gray-600 truncate font-semibold dark:hover:text-white hover:underline",
      className
    )}
    href={url}
    target="_blank"
    rel="noreferrer"
  >
    {text}
    <Icon className={"h-3 w-3 inline ml-1 flex-shrink-0"} style={iconStyle} />
  </a>
);

export default ExternalLink;
